import React from 'react';
import './AdCounter.css';

export default ({
  adminCheck,
  adminCheckStep,
  videoStep,
  onCheckChange,
  onStepChange,
  onVideoStepChange,
  onMinusClick,
  onPlusClick,
}) => (
  <div className="AdCounter">
    <div className="AdGroup">
      <span>Счетчик:</span>
      <input
        type="number"
        step="1"
        min="0"
        value={adminCheck}
        onChange={onCheckChange}
      />
      <button onClick={onMinusClick}>
        <div className="fontawesome-minus" />
      </button>
      <input
        type="number"
        step="1"
        min="1"
        value={adminCheckStep}
        onChange={onStepChange}
      />
      <button onClick={onPlusClick}>
        <div className="fontawesome-plus" />
      </button>
    </div>
    <div className="StepGroup">
      <span>Шаг:</span>
      <input
        type="number"
        step="1"
        min="1"
        value={videoStep}
        onChange={onVideoStepChange}
      />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tools/VideoTool/AdCounter.jsx